// Global
import React, { useState, useEffect } from 'react';
//import { NextImage } from '@sitecore-jss/sitecore-jss-nextjs';

// Lib
import { BoK } from 'lib/templates/Feature.BOKF.model';
import { ComponentProps } from 'lib/component-props';

// Local
import RichTextA11yWrapper from 'helpers/RichTextA11yWrapper/RichTextA11yWrapper';
import LinkWrapper from 'helpers/LinkWrapper/LinkWrapper';
import ImageWrapper from 'helpers/ImageWrapper/ImageWrapper';
import shuffle from 'lodash/shuffle';

export type StaticAdProps = { fields: { items: BoK.Content.StaticAd[] } };
export type PromoBoxProps = StaticAdProps & ComponentProps;

export const PromoBox = (props: PromoBoxProps): JSX.Element => {
  const staticAd = props?.fields?.items || [];

  const numberToDisplay = Number(props?.params[`Number to Display`]) || 3;
  const randomOrder = Boolean(!!+props?.params[`Random Order`]) || false;

  const staticAdsOriginal = staticAd.slice(0, numberToDisplay);
  const [staticAds, setStaticAds] = useState<BoK.Content.StaticAd[]>(staticAdsOriginal);
  const [hasShuffled, setHasShuffled] = useState(false);

  useEffect(() => {
    if (randomOrder && !hasShuffled) {
      const newStaticAds = shuffle(staticAds);
      setStaticAds(newStaticAds);
      setHasShuffled(true);
    }
  }, [randomOrder, hasShuffled, staticAds]);
  if (!props?.fields) {
    return <></>;
  }

  const gridColumnNumber = () => {
    if (numberToDisplay === 1) {
      return 'grid-cols-1';
    } else if (numberToDisplay === 2) {
      return 'grid-cols-1 @3xl:grid-cols-2';
    } else if (numberToDisplay === 3) {
      return 'grid-cols-1 @3xl:grid-cols-2 @6xl:grid-cols-3';
    } else {
      return 'grid-cols-1 @3xl:grid-cols-2 @7xl:grid-cols-4';
    }
  };

  return (
    <section className="component promo-box container spacing-md" data-id="promo-box">
      <div className={`grid ${gridColumnNumber()} w-full gap-6 py-6 lg:py-8`}>
        {staticAds?.map((item, key) => (
          <LinkWrapper
            field={{ value: { href: item?.fields?.Link?.value?.href } }}
            className={`${
              !item?.fields?.Image?.value?.src ? '' : 'grid grid-cols-[max-content_1fr]'
            } gap-x-4 h-full shadow-small hover:shadow-hover focus:outline focus:outline-2 focus:outline-light-stroke-primary-variant focus:outline-offset-[-2px] hover:no-underline`}
            key={key}
          >
            {item?.fields?.Image && (
              <ImageWrapper
                key={key}
                field={item?.fields?.Image}
                className="max-w-[86px] md:max-w-[76px] lg:max-w-[120px] h-full object-cover"
                height="120"
                width="120"
              />
            )}
            {item?.fields?.Title && (
              <RichTextA11yWrapper
                field={item?.fields?.Title}
                className={`p2-medium flex items-center py-4 ${
                  !item?.fields?.Image?.value?.src ? 'px-4' : 'pr-4'
                }`}
              />
            )}
          </LinkWrapper>
        ))}
      </div>
    </section>
  );
};

export default PromoBox;
